import {QbAjaxRequest} from "../business/qbrequest"

export class KPIController {

	static EVENT_TYPE = {
		SHARE: 'share',
		PLAY: 'play'
	}

	static EVENT_SUBTYPE = {
		SHARE: {
			FACEBOOK: 'facebook',
			TWITTER: 'twitter',
			EMAIL: 'email'
		},
		PLAY: {
			STARTED: 'started',
			QUALIFIED: 'qualified'
		}
	}

	static RESOURCES_TYPE = {
		ALBUM: 'album',
		ARTIST: 'artist',
		TRACK: 'track'
	}

	/**
	 * Reports a play event to Qobuz API
	 * @param {KPIController.EVENT_SUBTYPE.PLAY} subtype
	 * @param {KPIController.RESOURCES_TYPE} resource
	 * @param {string|number} id
	 */
	static pushPlayEvent(subtype, resource, id) {
		KPIController._pushEvent(KPIController.EVENT_TYPE.PLAY, subtype, resource, id)
	}

	/**
	 * Reports a share event to Qobuz API
	 * @param {KPIController.EVENT_SUBTYPE.SHARE} subtype
	 * @param {KPIController.RESOURCES_TYPE} resource
	 * @param {string|number} id
	 */
	static pushShareEvent(subtype, resource, id) {
		KPIController._pushEvent(KPIController.EVENT_TYPE.SHARE, subtype, resource, id)
	}

	/**
	 * Reports an event to Qobuz API
	 * @param {KPIController.EVENT_TYPE} type
	 * @param {KPIController.EVENT_SUBTYPE.SHARE|KPIController.EVENT_SUBTYPE.PLAY} subtype
	 * @param {KPIController.RESOURCES_TYPE} resource
	 * @param {string|number} id
	 */
	static _pushEvent(type, subtype, resource, id) {
		QbAjaxRequest.postJson('event', 'report', {
			version: '01.00',
			events: [{
				date: Math.floor(Date.now() / 1000),
				event_type: type,
				event_subtype: subtype,
				resource_type: resource,
				resource_id: `${id}`,
				origin: location.href
			}]
		})
	}
}



// WEBPACK FOOTER //
// ./src/utils/kpi/KPIController.js